import { featureIdCode } from '@/components/ballot-map/map-ids'
import { areaFillColor } from '@/components/MapsShared/shared'
import { useGeodata } from '@/components/ballot-map/use-geodata'
import * as M from '@/materials'
import { FillStyleExtension } from '@deck.gl/extensions'
import { GeoJsonLayer } from '@deck.gl/layers'
import DeckGL from '@deck.gl/react'
import styled from '@emotion/styled'
import * as React from 'react'
import { useBallotContext } from '@/contexts'
import { BallotState, CantonId, CantonState, caseBallotState, unCantonId } from '@/domain/index'
import { useFitBoundingBox } from '@/hooks/use-deckgl-zoom'
import { hex2rgb } from '@/materials/color'

import fillPatternMapping from '../../../../public/textures/municipality.json'
const fillPatternAtlas = `data:image/png;base64,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`

const fillLake = () => hex2rgb(M.lakeColor)

export interface NationalMapProps {
  date: Date
  width: number
  includeLakes: boolean
  state: BallotState
  cantons: Array<CantonState>
  selectedCantonId?: CantonId
  onSelectCanton?: (id: CantonId) => void
  onResetSelection?: () => void

  /**
   * Returns the fill color for the given canton.
   */
  fill?: (cantonId: CantonId) => M.CSSColor
}

const INITIAL_VIEW_STATE = {
  latitude: 46.8182,
  longitude: 8.2275,
  zoom: 6.5,
  maxZoom: 10,
  minZoom: 2,
  pitch: 0,
  bearing: 0,
}

const aspectRatio = 400 / 256

function nationalMapProportions(width: number) {
  /*
   * Use a fixed aspect ratio, so we can calculate the height from the width.
   */
  const height = width / aspectRatio

  /*
   * 1.2 looks good on large maps, less than 0.6 is too thin.
   */
  const strokeWidth = () => Math.min(1.2, Math.max(0.2, width / 500))

  return { width, height, strokeWidth }
}

const SwitzerlandCantonsMap = React.memo<NationalMapProps>((props) => {
  const { date, includeLakes, cantons: cantonsProps, onSelectCanton, onResetSelection, fill: fillProp } = props
  const year = date.getUTCFullYear()

  const { ballotVariant } = useBallotContext()

  const { width, height, strokeWidth } = React.useMemo(() => nationalMapProportions(props.width), [props.width])

  const cantonFill = React.useCallback(
    ({ id }: { id?: string | number }): number[] => {
      const code = featureIdCode(id as number)
      if (code && fillProp) {
        return hex2rgb(fillProp(code))
      }

      const mbCanton = cantonsProps.find((x) => unCantonId(x.id) === code)
      if (mbCanton) {
        return hex2rgb(areaFillColor(mbCanton.state, ballotVariant))
      } else {
        return hex2rgb(M.color.grey['300'])
      }
    },
    [ballotVariant, cantonsProps, fillProp],
  )

  /*
   * Load the GeoJSON data.
   */
  const { country, cantons, lakes } = (function useSilence() {
    return {
      cantons: useGeodata({ year, feature: 'cantons' }).data,
      lakes: useGeodata({ year, feature: 'lakes' }).data,
      country: useGeodata({ year, feature: 'country' }).data,
    }
  })()

  const [hoveredCanton, setHoveredCanton] = React.useState<null | number>(null)

  const handleCantonHover = ({ object }: { object: { id: number } }) => {
    if (onSelectCanton) {
      if (object?.id) {
        setHoveredCanton(object.id)
        const cantonId = featureIdCode(object.id)
        if (cantonId) {
          onSelectCanton(cantonId)
        }
      } else {
        setHoveredCanton(null)
        if (onResetSelection) {
          onResetSelection()
        }
      }
    }
  }

  const shouldApplyMaterial = (state: BallotState) =>
    caseBallotState({
      pre: false,
      inProgress: false,
      trend: () => false,
      projection: () => true,
      finalResult: () => false,
    })(state)

  const handleCantonFill = ({ id }: { id: number }) => {
    const code = featureIdCode(id as number)
    const canton = cantonsProps.find((x) => unCantonId(x.id) === code)
    if (canton) {
      return shouldApplyMaterial(canton.state) ? 'hatch' : 'fill'
    }
    return 'fill'
  }

  const layers = [
    new GeoJsonLayer({
      id: 'cantons',
      data: cantons,
      pickable: true,
      filled: true,
      stroked: true,
      lineJointRounded: true,
      getLineWidth: strokeWidth() * 100,
      onHover: handleCantonHover,
      lineWidthMinPixels: 0.5,
      getFillColor: cantonFill,
      getLineColor: [255, 255, 255, 255],
      updateTriggers: {
        getFillColor: cantonFill,
        getLineColor: [255, 255, 255, 255],
        getLineWidth: strokeWidth() * 100,
        getFillPattern: handleCantonFill,
      },
      extensions: [new FillStyleExtension({ pattern: true })],
      fillPatternMask: true,
      fillPatternEnabled: true,
      fillPatternAtlas,
      fillPatternMapping,
      getFillPattern: handleCantonFill,
      getFillPatternScale: 100,
      getFillPatternOffset: [0, 0],
    }),
    includeLakes &&
      new GeoJsonLayer({
        id: 'lakes',
        data: lakes,
        filled: true,
        lineJointRounded: true,
        getFillColor: fillLake,
      }),
    new GeoJsonLayer({
      id: 'hover',
      data: cantons
        ? {
            ...cantons,
            features: cantons?.features.filter((x) => x.id === hoveredCanton),
          }
        : [],
      pickable: false,
      filled: false,
      stroked: true,
      lineJointRounded: true,
      getLineWidth: strokeWidth() * 1000,
      lineWidthMinPixels: 0.5,
      getLineColor: [33, 33, 33, 255],
    }),
  ]

  const autoAjustZoom = useFitBoundingBox(country?.features[0])

  const viewState = React.useMemo(() => {
    return autoAjustZoom({ ...INITIAL_VIEW_STATE, width, height }, -0.1)
  }, [width, height, autoAjustZoom])

  return (
    <Root
      style={{
        maxHeight: height,
        position: 'relative',
        width,
        height,
      }}
    >
      <DeckGL
        viewState={viewState}
        controller={false}
        layers={layers}
        width={width}
        height={height}
        style={{ width, height }}
      />
    </Root>
  )
})

export default SwitzerlandCantonsMap

export const Root = styled('div')`
  label: SwitzerlandCantonsMap;

  & > div {
    touch-action: unset !important;
  }
`
